import { useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { IconChevronRight } from '~/domains/design-system/icons/IconChevronRight';
import { LinkNew } from '~/domains/common/components/Link/Link';
import { Routes } from '~/domains/common/constants/routes';

import { reportPredictionsWidgetAllMarketsTapped } from '../../analyticsEvents';

import { WIDGET_LOCATION } from './constants';
import { useStyles } from './HomePredictionMarkets.styles';

export function AllPredictionsLink() {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const { t } = useTranslation('market');

  return (
    <LinkNew
      href={Routes.markets()}
      onClick={() => reportPredictionsWidgetAllMarketsTapped({ location: WIDGET_LOCATION })}
      className={classes.viewAllLink}
    >
      <Text variant="subhead-medium" color="gray2.3">
        {t('homeWidget.allPredictions')}
      </Text>
      <IconChevronRight size={16} color={theme.colors.gray2[3]} />
    </LinkNew>
  );
}
